import { RELATORIO_USO_MUTUO } from '../constants/modules';
import { hasModuleConfiguration } from './moduleConfigurationPermission';

/**
 * Quem pode acessar /v2/relatorio-uso-mutuo e exportar relatório de pesagem sucata.
 * Requer module configuration RELATORIO_USO_MUTUO vinculada ao userId logado
 * (ou e-mail vinicius_admin).
 */
export function canViewUsoMutuoReport({ authData, moduleConfigurations }) {
  return hasModuleConfiguration(moduleConfigurations, authData, RELATORIO_USO_MUTUO);
}
